import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.clearfix::after {
    content: "";
    display: table;
    clear: both;
}

html,
body {
    font-family: 'Open Sans', sans-serif !important;
    font-weight: normal;
    font-size: 16px;
}

a {
    text-decoration: none;
    color:inherit;
}
`;